import { getAuth } from 'firebase/auth';

export class RefreshAuthTokenUseCase {
  static async execute() {
    await getAuth().currentUser?.getIdToken(true);
  }
}
